import axios from "axios";
import {apiUri} from "../../config";
import {push} from "connected-react-router";
import { NotificationManager } from 'react-notifications';

export const FETCH_DANDOS_ATTEMPT = 'FETCH_DANDOS_ATTEMPT';
export const FETCH_DANDOS_SUCCESS = 'FETCH_DANDOS_SUCCESS';
export const FETCH_DANDOS_FAILURE = 'FETCH_DANDOS_FAILURE';

export const CREATE_DANDOS_ATTEMPT = 'CREATE_DANDOS_ATTEMPT';
export const CREATE_DANDOS_SUCCESS = 'CREATE_DANDOS_SUCCESS';
export const CREATE_DANDOS_FAILURE = 'CREATE_DANDOS_FAILURE';

export const FETCH_DANDO_ATTEMPT = 'FETCH_DANDO_ATTEMPT';
export const FETCH_DANDO_SUCCESS = 'FETCH_DANDO_SUCCESS';
export const FETCH_DANDO_FAILURE = 'FETCH_DANDO_FAILURE';

export const SELECT_DANDO = 'SELECT_DANDO';

export const FETCH_CASE = 'FETCH_CASE';

export const DANDO_UPDATE = 'DANDO_UPDATE';
export const DANDO_CREATE_FORM = 'DANDO_CREATE_FORM';

global.loader = false;

export const fetch_dandos = ({page=0, search='', sortKey='', sortOrder=''}) => {
	return (dispatch) => {
		dispatch({type: FETCH_DANDOS_ATTEMPT, page: page});
		axios.get(apiUri + "/dando?page=" + page + "&search=" + search  + "&sortField=" + sortKey + "&order=" + sortOrder)
			.then(json => {
				const response = json.data;
				dispatch({
					type: FETCH_DANDOS_SUCCESS,
					data: response.content,
					page: page,
					total_pages: response.totalPages
				})
			})
			.catch(err => {
				dispatch({type: FETCH_DANDOS_FAILURE, error: err})
			})
	}
};

export const select_dando = (dando_id) => {
	return (dispatch) => {
		dispatch({type: SELECT_DANDO, id: dando_id});
		dispatch(push("/dando/" + dando_id));
	}
};

export const select_case = (caseId) => {
	return (dispatch) => {
		axios.get(apiUri + "/cases/caseInfo/" + caseId)
			.then(json => {
				const response = json.data;
				dispatch({
					type: FETCH_CASE,
					data: response
				});
			})
			.catch(err => {
				dispatch({type: FETCH_DANDOS_FAILURE, error: err})
			})
	}
};

export const updatePurchaseType = (id , Usertype,Type) => {
	var urlType = apiUri + "/dando/"+id;
	if(Type==='CUSTOM'){
		urlType = urlType+"_"+Type;      
	}
	 return (dispatch) => {
	   
		axios.put(urlType,'')
		.then(json => {
			global.loader = false;
			NotificationManager.success("Risk Assessment Saved Successfully");
		   dispatch(push("/dandos"));

		})
		.catch(err => {
			console.log("Failed to create dando " + err);
			global.loader = false;
			NotificationManager.error("Failed to create dando" + err);
			dispatch({type: CREATE_DANDOS_FAILURE, error: err.response.data.message})
		})
	 }
};

export const create_dando = (data,isSubscribe) => {
   
	//const pathname = window.location.pathname;
	
	 return (dispatch) => {
	   
		dispatch({type: CREATE_DANDOS_ATTEMPT});
		axios.post(apiUri + "/dando",data)
			.then(json => {
				dispatch({type: CREATE_DANDOS_SUCCESS, data: json});
				//dispatch(updatePurchaseType(json.data.data.id , isSubscribe ? 'SUBSCRIBER' : 'NONSUBSCRIBER',pathname.includes("/dandos/create")&&'CUSTOM'))
				global.loader = false;
				NotificationManager.success("Risk Assessment Saved Successfully");
				dispatch(push("/dandos"));
			})
			.catch(err => {     
				console.log("Failed to create dando----> " + err);
				global.loader = false;
				NotificationManager.error("Failed to create dando" + err);
				dispatch({type: CREATE_DANDOS_FAILURE, error: err.response.data.message})
			})
	 }
};


export const dandoUpdate = UpdateDandOId => {
	return dispatch => {
			axios.get(apiUri + "/dando/"+ UpdateDandOId)
			.then(json => {
				dispatch({type: DANDO_UPDATE, 
					UpdateDandOResult: json.data})
			})
			.catch(err => {
				console.log("Failed to create risk assessment " + err);
				dispatch({type: CREATE_DANDOS_FAILURE, error: err.response.data.message})
			})
	};
};
export const dandoForm = formDetails => {
	return dispatch => {
		dispatch({type:DANDO_CREATE_FORM,dandoForm:formDetails})
	};
};


// WEBPACK FOOTER //
// ./src/dandos/redux/actions.js